import * as _ from "lodash";

import { Input, Select } from "@/components";
import { Map } from "@/utils";

import SettingsStep from "../Step";

const renderFormControls = ({ formState, changeFormState, FormControl }) => {
    const positioningTypeOptions = _.map(
        Map.Collections.positioningTypes,
        (positionType) => ({
            value: positionType,
            label: positionType,
        }),
    );

    return (
        <div>
            <div className="text">
                Before you get started placing lights, we need some about the
                fixtures in the space. This will give you a more focused
                experience.
            </div>
            <div className="row">
                <FormControl
                    className="col-sm-5"
                    name="positioningType"
                    required
                >
                    <label className="selectLabel">
                        Positioning Type<span className="asterisk">*</span>
                    </label>
                    <Select
                        required
                        value={formState.positioningType}
                        name="positioning-type"
                        onChange={({ value }) =>
                            changeFormState({
                                positioningType: value,
                            })
                        }
                        options={positioningTypeOptions}
                    />
                </FormControl>
            </div>
            <div className="row">
                <FormControl className="col-sm-4" name="operationPoint">
                    <Input
                        value={formState.operatingPoint}
                        label="Operating Point"
                        onChange={(value) =>
                            changeFormState({
                                operatingPoint: value,
                            })
                        }
                        type="number"
                    />
                </FormControl>
                <FormControl
                    className="col-sm-5 max-mounting-height"
                    name="maxMountingHeight"
                    required
                >
                    <Input
                        value={formState.maxMountingHeight}
                        label="Max Mounting Height (feet)"
                        onChange={(value) =>
                            changeFormState({
                                maxMountingHeight: value,
                            })
                        }
                        decimalDigits={2}
                        type="number"
                        required
                    />
                </FormControl>
            </div>
            <div className="row">
                <FormControl className="col" name="fixturesTypes">
                    <label>Fixture Types</label>
                    <Select
                        multi
                        placeholder="Filter and select one or more fixture types…"
                        name="fixtureTypes"
                        value={formState.types}
                        options={Map.Collections.fixtureTypes}
                        onChange={(selectedOptions) =>
                            changeFormState({
                                types: selectedOptions,
                            })
                        }
                    />
                </FormControl>
            </div>
        </div>
    );
};

/**
 * Wizard step for the fixture catalog and mounting details.
 *
 * @param props - The settings step props, forwarded verbatim.
 * @returns The rendered fixture step.
 */
const FixtureStep = (props) => (
    <SettingsStep {...props} renderFormControls={renderFormControls} />
);

export default FixtureStep;
